<template>
  <section class="recommend-box">
    <h3>热门推荐</h3>
    <ul class="recommend-list">
      <li class="recommend-item">
        <a href="#" target="_blank">
          <img src="../../assets/images/car.jpg" />
          <span class="video-time">01:33</span>
          <p>非常特别的古董车聚非常特别的古董车聚…</p>
        </a>
        <div class="aside">
          2017.09.18
          <a href="#" class="read-to-app" target="_blank">去App阅读</a>
        </div>
      </li>
      <li class="recommend-item">
        <a href="#" target="_blank">
          <img src="../../assets/images/car.jpg" />
          <span class="video-time">01:33</span>
          <p>非常特别的古董车聚</p>
        </a>
        <div class="aside">
          2017.09.18
          <a href="#" class="read-to-app" target="_blank">去App阅读</a>
        </div>
      </li>
    </ul>
  </section>
</template>
<script>
  export default {
    name: 'top-focus',
    created: function () {
      console.log(11)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/video/recommend-video.vue